import React from 'react';
import {AppShell, Box, Group, Text, UnstyledButton} from '@mantine/core';
import {IconBell, IconChartBar, IconGauge, IconLayoutGrid, IconSearch} from '@tabler/icons-react';
import {Link, useLocation} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import classes from './BottomNav.module.css';

type BottomNavItem = {
  label: string;
  icon: typeof IconGauge;
  /** React route (relative to the router basename). */
  link?: string;
  onClick?: () => void;
};

export const BOTTOM_NAV_HEIGHT = 64;

interface BottomNavProps {
  onOpenSearch: () => void;
}

export default function BottomNav({ onOpenSearch }: BottomNavProps) {
  const { t } = useTranslation();
  const { pathname } = useLocation();

  const items: BottomNavItem[] = [
    { link: '/dashboard', label: t('Dashboard'), icon: IconGauge },
    { link: '/sitemap', label: t('Sitemap'), icon: IconLayoutGrid },
    { link: '/charts-home', label: t('Charts'), icon: IconChartBar },
    { label: t('Search'), icon: IconSearch, onClick: onOpenSearch },
    { label: t('Notifications'), icon: IconBell },
  ];

  return (
    <AppShell.Footer hiddenFrom="lg">
      <Box maw={720} mx="auto" h="100%">
        <Group h="100%" gap={0} wrap="nowrap" component="nav">
          {items.map(({ link, label, icon: Icon, onClick }) => {
            const active = !!link && (pathname === link || pathname.startsWith(`${link}/`));
            const linkProps = link ? { component: Link, to: link } : { onClick };

            return (
              <UnstyledButton
                key={label}
                {...(linkProps as object)}
                className={classes.item}
                data-active={active || undefined}
                aria-label={label}
              >
                <Icon size={22} stroke={1.6} />
                <Text size="xs" inherit>
                  {label}
                </Text>
              </UnstyledButton>
            );
          })}
        </Group>
      </Box>
    </AppShell.Footer>
  );
}
